/* eslint-disable jsx-a11y/anchor-is-valid */
import Text, { TEXT_TYPE } from "component/design-system/typography/Text";
import Link from "next/link";
import { useRouter } from "next/router";
import { getPathNamefromAsPath } from "util/helper/getPathNamefromAsPath";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";
import PAImage from "../images/PAImage";
import PAText, { FONT_SIZE } from "../typography/PAText/PAText";
import styles from "./categorySlectionCardBig.module.scss";

function CategorySlectionCardBig(props: any) {
  const {
    linkDetails = {}, imageProps = {}, jsLink = false,
    tier, imageUrl, title, description, url,
  } = props;

  const queryString = url.split("?")[1];
  const pathnameFromUrl = getPathNamefromAsPath(url);
  const { href, asPath } = getHrefAndPath({ queryString, asPath: pathnameFromUrl });
  const router = useRouter();

  if (!imageProps.width || !imageProps.height) {
    imageProps.width = 200;
    imageProps.height = 200;
  }

  const updatedTitle = title || linkDetails.title || tier;
  const updatedDescription = description || linkDetails.description;

  const renderChild = (
    <>

      <div className={styles.image_container}>

        <PAImage
          {...imageProps}
          unoptimized
          src={getRelativeImagePath(imageUrl || linkDetails.imageUrl || "/images/home/sample-img.png")} // For yearmakemodel page we  don't get linkdetails
          alt={`Enhance your car with ${updatedTitle}`}
          title={`Enhance your car with ${updatedTitle}`}
        />
      </div>

      <div className={styles.content}>
        {(updatedTitle) && (
          <PAText component="h3" fontSize={FONT_SIZE[2]} className="m-t-10" color="black">
            {updatedTitle}
          </PAText>

        )}
        {(updatedDescription) && (
          <Text
            size={6}
            type={TEXT_TYPE.secondary}
            title={updatedDescription}
            className={styles.text}
          >
            {updatedDescription}
          </Text>
        )}
      </div>
    </>
  );

  if (jsLink) {
    return (
      <a onClick={(e) => {
        e.preventDefault();
        if (e.ctrlKey) {
          window.open(url, "_blank");
        } else {
          router.push(url)
            .then(() => window.scrollTo(0, 0));
        }
      }}
      >
        {renderChild}
      </a>
    );
  }
  return (
    <div className={styles.link_container}>
      <Link
        href={href}
        as={asPath}
        title={`Navigate Online Selections for ${updatedTitle}`}>

        {renderChild}

      </Link>
    </div>
  );
}

export default CategorySlectionCardBig;
